export const mapOptions = (data) => {
	const mapOptions = data?.map((iterator) => {
		return {
			label: iterator.name_editable,
			value: iterator.name,
		};
	});
	return mapOptions;
};
